export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Номер отчета', value: 'id', align: 'center' },
          { text: 'Время создания', value: 'created_at', align: 'center' },
          { text: 'Время обновления', value: 'updated_at', align: 'center' },
          { text: 'Бонусы', value: 'bonuses', align: 'center' },
          { text: 'Статус', value: 'status', align: 'left', sortable: false },
          { text: 'Действия', value: 'actions', align: 'center', sortable: false },
        ],
        subHeaders: [
          { text: 'Номер позиции', value: 'id', align: 'center' },
          { text: 'Изделие', value: 'product', align: 'center', sortable: false },
          { text: 'Бонусы', value: 'bonuses', align: 'center' },
          { text: '', value: '', align: 'center' },

        ],
      },
      history: [],
      showHistoryID: false,
      editStatuses: ['adminReview', 'draft', 'redo'],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    sales() {
      return this.$store.state.sales.sales;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },

    getSaleQuantity(id) {
      const sale = this.sales.filter(item => item.id === id);
      let quantity = 0;
      if (sale[0].positions) {
        quantity = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getSaleBonuses(id) {
      const sale = this.sales.filter(item => item.id === id);
      let bonuses = 0;
      if (sale[0].positions) {
        bonuses = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    addSale(id, actionId) {
      this.$store.dispatch('sales/GetSale', id);
      this.$router.push(`/sale/${actionId}/${id}`);
    },
    showHistory(id) {
      const sale = this.sales.filter(item => item.id === id);
      this.history = sale.length ? sale[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        default: return '';
      }
    },
  },
  mounted() {
    this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
    this.$store.dispatch('sales/GetProductsList');
  },
};
